export default [
    { id: 1, name: 'married', label: 'Casado' },
    { id: 2, name: 'single', label: 'Solteiro' },
    { id: 3, name: 'divorced', label: 'Divorciado' },
    { id: 4, name: 'serious', label: 'União estável' },
    { id: 5, name: 'others', label: 'Outro' },
    { id: 6, name: 'widower', label: 'Viúvo' },
    { id: 7, name: 'separated', label: 'Separado' },
]